import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getOutstandingPayouts = {
  name: "getOutstandingPayouts" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    payouts: z.array(
      z.object({
        _id: zExt.objectId(),
        status: z.string(),
        charge: z.object({ currency: z.string(), price: z.string() }),
        createdAt: z.string(),
        payoutOrderCount: z.number(),
      }),
    ),
  }),
};
